import { render, staticRenderFns } from "./CrewNew.vue?vue&type=template&id=f47f8e52&"
import script from "./CrewNew.vue?vue&type=script&lang=js&"
export * from "./CrewNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports